import React from 'react';
import CurrencySelectProperties from "./CurrencySelectProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import SelectOption from "../../../ui_components/Select/SelectOption";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import Select from "../../../ui_components/Select/Select";
import Currency from "../../../entities/Currency";

const CurrencySelect: React.FC<CurrencySelectProperties> = ({
                                                                        selected,
                                                                        showSelectAllOption = false,
                                                                        excludedCurrencies = [],
                                                                        label = '',
                                                                        onChange,
                                                                        disabled,
                                                                        fullWidth = false,
                                                                        className = '',
                                                                        error,
                                                                        showClearButton = false
                                                                    }) => {

    const i18n = useI18nContext();

    let opt = showSelectAllOption ? [new SelectOption(i18n.translate("ALL_FEMALE"), "ALL", 'Todas las monedas', LocalAtmIcon)] : [];

    if (!excludedCurrencies.includes(Currency.DOLLAR) && !excludedCurrencies.includes(Currency.USD)) {
        opt.push(new SelectOption(i18n.translate("DOLLAR"), "DOLLAR", i18n.translate("DOLLAR"), LocalAtmIcon));
    }

    if (!excludedCurrencies.includes(Currency.MN)) {
        opt.push(new SelectOption(i18n.translate("MN"), "MN", i18n.translate("MONEDA_NACIONAL"), LocalAtmIcon));
    }

    if (!excludedCurrencies.includes(Currency.MLC)) {
        opt.push(new SelectOption('MLC', "MLC", 'MLC', LocalAtmIcon));
    }

    const selectedOption = opt.find(t => t.value === selected);

    const onStatusChange = (option: SelectOption) => {
        onChange(option.value as Currency)
    }

    return (
        <Select
            error={error}
            className={className}
            disabled={disabled}
            fullWidth={fullWidth}
            label={label && label !== '' ? label : i18n.translate("CURRENCY")}
            placeholder={i18n.translate("CURRENCY_PLACEHOLDER")}
            selected={selectedOption}
            icon={LocalAtmIcon}
            onChange={onStatusChange}
            elements={opt}
            showClearButton={showClearButton}
        />
    )
}


export default CurrencySelect;